import workoutsApi from '@/services/api/workoutsApi';
import {
  baseActions, baseGetters, baseMutations, baseState,
} from '@/store/components/base';
import {
  sortActions, sortGetters, sortMutations, sortState,
} from '@/store/components/sort';
import {
  paginationActions, paginationGetters, paginationMutations, paginationState,
} from '@/store/components/pagination';

const initialState = () => ({
  ...baseState,
  ...sortState,
  ...paginationState,
});

export default {
  namespaced: true,
  state: initialState,
  actions: {
    ...baseActions,
    ...sortActions,
    ...paginationActions,
    async fetchItems({ state, commit }) {
      commit('setFetchProgress', true);
      try {
        const params = {
          // sortType: state.sortType,
          // sortDirection: state.sortDirection,
          // search: state.searchText || null,
          // pageNumber: state.page,
          // is_favorite: false,
          per_page: state.pageSize,
          offset: (state.page - 1) * state.pageSize,
          // tag: '',
        };
        const {
          items,
          count,
          // page,
          // per_page: perPage,
          // total,
          // total_pages: totalPages,
        } = await workoutsApi.fetchItems({ params });
        commit('setItems', items);
        commit('setCount', count);
        // commit('setPage', pageNumber);
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка загрузки тренировок'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setFetchProgress', false);
      }
    },

    async fetchItem({ state, commit }) {
      if (!state.itemId) return;
      commit('setFetchItemProgress', true);
      try {
        const response = await workoutsApi.fetchItem({ id: state.itemId });
        commit('setItem', response);
        return response;
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка загрузки тренировки'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setFetchItemProgress', false);
      }
    },

    async createItem({ commit, dispatch }, { data }) {
      commit('setCreateProgress', true);
      try {
        const response = await workoutsApi.createItem({ data });
        dispatch('fetchItems');
        commit('notifications/addNotifySuccess', ['Тренировка успешно создана'], { root: true });
        return response;
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка создания тренировки'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setCreateProgress', false);
      }
    },

    async updateItem({ commit, dispatch }, { id, data }) {
      commit('setUpdateProgress', true);
      try {
        const response = await workoutsApi.updateItem({ id, data });
        commit('setItem', response.data);
        dispatch('fetchItems');
        commit('notifications/addNotifySuccess', ['Тренировка успешно изменена'], { root: true });
        return response;
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка редактирования тренировки'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setUpdateProgress', false);
      }
    },

    // async deleteItem({ commit, dispatch }, { id }) {
    //   commit('setDeleteProgress', true);
    //   try {
    //     const response = await workoutsApi.deleteItem({ id });
    //     dispatch('fetchItems');
    //     commit('notifications/addNotifySuccess', ['Специалист успешно удален'], { root: true });
    //     return response.data;
    //   } catch (err) {
    //     commit('notifications/addNotifyErrors', ['Ошибка удаления тренировки'], { root: true });
    //     return Promise.reject(err);
    //   } finally {
    //     commit('setDeleteProgress', false);
    //   }
    // },

    async changeVisibility({ commit, dispatch }, { id, data }) {
      commit('setUpdateProgress', true);
      try {
        const response = await workoutsApi.changeVisibility({ id, data });
        dispatch('fetchItem');
        dispatch('fetchItems');
        commit('notifications/addNotifySuccess', ['Видимость успешно изменена'], { root: true });
        return response.data;
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка изменения видимости'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setUpdateProgress', false);
      }
    },

    async updateImg({ commit }, { type, file }) {
      commit('setUpdateProgress', true);
      const data = new FormData();
      data.append(type, file.raw);
      try {
        const response = await workoutsApi.updateImg({ type, data });
        commit('notifications/addNotifySuccess', ['Изображение успешно загружено'], { root: true });
        return response;
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка загрузки изображения'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setUpdateProgress', false);
      }
    },
  },
  mutations: {
    ...baseMutations,
    ...sortMutations,
    ...paginationMutations,
    clearState(state) {
      Object.entries(initialState()).forEach(([key, value]) => { state[key] = value; });
    },
  },
  getters: {
    ...baseGetters,
    ...sortGetters,
    ...paginationGetters,
    searchText: (state) => state.searchText,
  },
};
